<template>
  <div class="uploaded-page">
    <div class="tab">
      <van-tabs
        class="first_tab"
        color="#FF6927"
        line-width="0"
        title-active-color="#FF6927"
        @click="onClick"
      >
        <van-tab title="上传" name="upload"></van-tab>
        <!-- <van-tab :title="'原创文章'+shareNum" name="originate">
        </van-tab>-->
        <van-tab title="分享" name="share"></van-tab>
      </van-tabs>
      <van-tabs
        class="secondTab"
        color="#FF6927"
        title-active-color="#FF6927"
        line-width="20"
        @click="changeUpLoadType"
        v-model="upLoadType"
      >
        <van-tab title="文章" name="ARTUPLD"></van-tab>
        <van-tab title="图文" name="PAW"></van-tab>
        <van-tab title="视频" name="VOD"></van-tab>
        <van-tab title="原创" name="ARTORIG"></van-tab>
      </van-tabs>
    </div>
    <div class="content" v-if="listType == 'upload'">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          class="customer_list"
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          :finished-text="finishedText"
          @load="onLoad"
        >
          <div v-if="upLoadListType == 'ARTUPLD'" class="article_list">
            <div
              class="list_item"
              v-for="(item, index) in uploadedList"
              :key="index"
              @click="goToDetails(item.artcId)"
            >
              <div class="article_pic_wrap">
                <!-- <img class="article_pic" v-lazy="item.coverlink" alt=""> -->
                <div class="article_info">
                  <div class="van-multi-ellipsis--l2 article_title">{{ item.title }}</div>
                </div>
                <van-image height="80" width="80" :src="item.coverLink" fit="cover" error-icon />
              </div>
              <div class="bot_info">
                <div class="date">{{ getFormatDate(item.pubDate) }}</div>
                <div class="btnBox">
                  <div
                    v-if="isAdmin"
                    @click="gotoEditPage($event, item.artcId)"
                    class="editBtn btn"
                  >
                    <img src="./img/edit.png" alt />
                    <div>编辑</div>
                  </div>
                  <div @click="delArticle($event, item.artcId)" class="delBtn btn">
                    <img src="./img/delBtn.png" alt />
                    <div>删除</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="upLoadListType == 'PAW'" class="img_list">
            <div class="list_item" v-for="(item, index) in uploadedList" :key="index">
              <div class="img_title">
               
                {{ item.artcSummary }}
              </div>
              <div class="img_wrap">
                <van-image :src="item.imgUrl1" fit="cover" error-icon />
                <van-image v-if="item.imgUrl2" :src="item.imgUrl2" fit="cover" error-icon />
                <van-image v-if="item.imgUrl3" :src="item.imgUrl3" fit="cover" error-icon />
                <van-image v-if="item.imgUrl4" :src="item.imgUrl4" fit="cover" error-icon />
                <van-image v-if="item.imgUrl5" :src="item.imgUrl5" fit="cover" error-icon />
                <van-image v-if="item.imgUrl6" :src="item.imgUrl6" fit="cover" error-icon />
                <van-image v-if="item.imgUrl7" :src="item.imgUrl7" fit="cover" error-icon />
                <van-image v-if="item.imgUrl8" :src="item.imgUrl8" fit="cover" error-icon />
                <van-image v-if="item.imgUrl9" :src="item.imgUrl9" fit="cover" error-icon />
              </div>
              <div class="bot_info">
                <div class="date">{{ getFormatDate(item.pubDate) }}</div>
                <div class="btnBox">
                  <div
                    v-if="isAdmin"
                    @click="gotoEditPage($event, item.artcId)"
                    class="editBtn btn"
                  >
                    <img src="./img/edit.png" alt />
                    <div>编辑</div>
                  </div>
                  <div @click="delArticle($event, item.artcId)" class="delBtn btn">
                    <img src="./img/delBtn.png" alt />
                    <div>删除</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="upLoadListType == 'VOD'" class="video_list">
            <div
              class="list_item video"
              v-for="(item, index) in uploadedList"
              :key="index"
              @click="goToDetails(item.artcId)"
            >
              <div class="video_title">{{ item.artcSummary }}</div>
              <div class="video_wrap">
                <img :src="item.faceImgUrl" width="320" height="180" />
              </div>
              <div class="bot_info">
                <div class="date">{{ getFormatDate(item.pubDate) }}</div>
                <div class="btnBox">
                  <div
                    v-if="isAdmin"
                    @click="gotoEditPage($event, item.artcId)"
                    class="editBtn btn"
                  >
                    <img src="./img/edit.png" alt />
                    <div>编辑</div>
                  </div>
                  <div @click="delArticle($event, item.artcId)" class="delBtn btn">
                    <img src="./img/delBtn.png" alt />
                    <div>删除</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="upLoadListType == 'ARTORIG'" class="article_list">
            <div
              class="list_item"
              v-for="(item, index) in uploadedList"
              :key="index"
              @click="goToDetails(item.artcId)"
            >
              <div class="article_pic_wrap">
                <div class="article_info">
                  <div class="van-multi-ellipsis--l2 article_title">{{ item.title }}</div>
                </div>
                <!-- <img class="article_pic" v-lazy="item.coverlink" alt=""> -->
                <van-image height="80" width="80" :src="item.coverLink" fit="cover" error-icon />
              </div>
              <div class="bot_info">
                <div class="date">{{ getFormatDate(item.pubDate) }}</div>
                <div class="btnBox">
                  <div
                    v-if="isAdmin"
                    @click="gotoEditPage($event, item.artcId)"
                    class="editBtn btn"
                  >
                    <img src="./img/edit.png" alt />
                    <div>编辑</div>
                  </div>
                  <div @click="delArticle($event, item.artcId)" class="delBtn btn">
                    <img src="./img/delBtn.png" alt />
                    <div>删除</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <van-empty v-if="noDataAll" description="暂无数据" /> -->
        </van-list>
      </van-pull-refresh>
    </div>

    <div class="content shareConten" v-if="listType == 'share'">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          class="customer_list"
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          :finished-text="finishedText"
          @load="onLoad"
        >
          <div v-if="upLoadListType == 'ARTUPLD'" class="article_list">
            <div
              class="list_item"
              v-for="(item, index) in shareList"
              :key="index"
              @click="goToDetails(item.artcId)"
            >
              <div class="article_pic_wrap">
                <!-- <img class="article_pic" v-lazy="item.coverlink" alt=""> -->
                <div class="article_info">
                  <div class="van-multi-ellipsis--l2 article_title">{{ item.title }}</div>
                </div>
                <van-image height="80" width="80" :src="item.coverLink" fit="cover" error-icon />
              </div>
              <div class="bot_info">
                <div class="date_share">{{ getFormatDate(item.pubDate) }}</div>
                <div class="shareTime">
                  访问{{ item.viewCount }}次&nbsp;&nbsp;分享{{
                  item.fwdCount
                  }}次
                </div>
              </div>
            </div>
          </div>
          <div v-if="upLoadListType == 'PAW'" class="img_list">
            <div class="list_item" v-for="(item, index) in shareList" :key="index">
              <div class="img_title">
                
                {{ item.artcSummary }}
              </div>
              <div class="img_wrap">
                <van-image :src="item.imgUrl1" fit="cover" error-icon />
                <van-image v-if="item.imgUrl2" :src="item.imgUrl2" fit="cover" error-icon />
                <van-image v-if="item.imgUrl3" :src="item.imgUrl3" fit="cover" error-icon />
                <van-image v-if="item.imgUrl4" :src="item.imgUrl4" fit="cover" error-icon />
                <van-image v-if="item.imgUrl5" :src="item.imgUrl5" fit="cover" error-icon />
                <van-image v-if="item.imgUrl6" :src="item.imgUrl6" fit="cover" error-icon />
                <van-image v-if="item.imgUrl7" :src="item.imgUrl7" fit="cover" error-icon />
                <van-image v-if="item.imgUrl8" :src="item.imgUrl8" fit="cover" error-icon />
                <van-image v-if="item.imgUrl9" :src="item.imgUrl9" fit="cover" error-icon />
              </div>
              <div class="bot_info">
                <div>{{ getFormatDate(item.pubDate) }}</div>
                <div class="shareTime">
                  访问{{ item.viewCount }}次&nbsp;&nbsp;分享{{
                  item.fwdCount
                  }}次
                </div>
              </div>
            </div>
          </div>
          <div v-if="upLoadListType == 'VOD'" class="video_list">
            <div
              class="list_item video"
              v-for="(item, index) in shareList"
              :key="index"
              @click="goToDetails(item.artcId)"
            >
              <div class="video_title">{{ item.artcSummary }}</div>
              <div class="video_wrap">
                <video
                  :src="item.vodUrl"
                  width="320"
                  height="180"
                  controls
                  :poster="item.faceImgUrl"
                ></video>
              </div>
              <div class="bot_info">
                <div>{{ getFormatDate(item.pubDate) }}</div>
                <div class="shareTime">
                  访问{{ item.viewCount }}次&nbsp;&nbsp;分享{{
                  item.fwdCount
                  }}次
                </div>
              </div>
            </div>
          </div>
          <div v-if="upLoadListType == 'ARTORIG'" class="article_list">
            <div
              class="list_item"
              v-for="(item, index) in shareList"
              :key="index"
              @click="goToDetails(item.artcId)"
            >
              <div class="article_pic_wrap">
                <div class="article_info">
                  <div class="van-multi-ellipsis--l2 article_title">{{ item.title }}</div>
                </div>
                <van-image height="80" width="80" :src="item.coverlink" fit="cover" error-icon />
              </div>
              <div class="bot_info">
                <div class="date">{{ getFormatDate(item.pubDate) }}</div>
                <div class="shareTime">
                  访问{{ item.viewCount }}次&nbsp;&nbsp;分享{{
                  item.fwdCount
                  }}次
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-overlay :show="delTip" class="delTip">
      <div class="wrapper">
        <div class="block">
          <h2>是否确认删除</h2>
          <div class="button_box">
            <div class="cancle" @click="cancel">取消</div>
            <div class="confirm" @click="confirmdelArticle">确认</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import URL from "@/api/api";
import wx from "weixin-js-sdk";
import { Tab, Tabs, List, Toast, Empty, Dialog } from "vant";
export default {
  name: "uploadedList",
  comments: {
    Tab,
    Tabs,
    List,
    Empty
  },
  data() {
    return {
      minUrl: "pages/sharePage/articlePage/articleShare.html?artcId=", //  小程序跳转页面路径
      minName: "",
      loading: false,
      finished: false,
      refreshing: false,
      upLoadType: "",
      listType: "upload",
      upLoadListType: "ARTUPLD",
      pageNum: 1, //请求第几页
      pageSize: 10, //每页请求的数量
      total: 0, //总共的数据条数
      finishedText: "我也是有底线的~~~",
      showUploadedList: true,
      showShareList: true,
      border: false,
      uploadNum: 0,
      shareNum: 0,
      color: "#5b9bd5",
      name: "upload",
      code: "",
      openId: "",
      appId: "",
      isAdmin: false,
      //测试假数据
      uploadedList: [],
      shareList: [],
      delTip: false,
      current_actId: ""
    };
  },

  created() {
    this.openId =
      sessionStorage.getItem("openId") ||
      sessionStorage.getItem("wechatnumber");
  },
  mounted() {
    if (location.hostname === "zf.dtfcloud.com") {
      this.minName = "gh_255fbfe5e3a1";
    } else {
      this.minName = "gh_9310bae62a18";
    }
    this.checkPower();
  },
  methods: {
    checkPower() {
      this.$fetchPost(URL.checkAuthority.url, {
        unionid: localStorage.getItem("unionid")
      }).then(res => {
        if (res) {
          if (res.data.data == false) {
            // this.isAdmin = true;
            this.isAdmin = false;
            this.getUploadedList();
          } else {
            this.isAdmin = true;
            this.getUploadedList();
          }
        }
      });
    },
    getUploadedList() {
      let that = this;
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true
      });
      that.$fetchPost(URL.getUploadList.url, {
        openid: this.isAdmin == true ? "" : that.openId,
        unionid:
          this.isAdmin == true ? "" : localStorage.getItem("unionid"),
        now_page: that.pageNum,
        row_num: that.pageSize,
        artcType: that.upLoadListType
      })
        .then(res => {
          Toast.clear();
          let list = res.data.list;
          that.uploadNum = res.data.total;
          that.refreshing = false;
          that.loading = false;
          Toast.clear();
          that.total = res.data.total;
          if (list == null || list.length === 0) {
            that.uploadedList = list;
            // 加载结束
            that.finished = true;
            that.finishedText = "暂无数据";
            return;
          }
          // 将新数据与老数据进行合并
          if (that.pageNum > 1) {
            that.uploadedList = [...that.uploadedList, ...list];
          } else {
            that.uploadedList = list;
          }
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (that.uploadedList.length >= that.total) {
            that.finished = true;
            that.finishedText = "我也是有底线的~~~";
          }
          // 如果总页数大于当前页码，页码+1
          if (res.data.pages > that.pageNum) {
            that.pageNum++;
          }
          if (that.uploadedList.length === 0) {
            that.showUploadedList = false;
          }
        });
    },
    getSharedList() {
      let that = this;
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true
      });
      that.$fetchPost(URL.getSharedList.url, {
        wechatNumber: this.isAdmin ? "" : that.openId,
        unionid: this.isAdmin ? "" : localStorage.getItem("unionid"),
        artcType: that.upLoadListType,
        now_page: that.pageNum,
        row_num: that.pageSize
      })
        .then(res => {
          Toast.clear();
          if (res.data.code === 20000) {
            let list = res.data.data.list;
            that.shareNum = res.data.data.total;
            that.refreshing = false;
            that.loading = false;
            Toast.clear();
            that.total = res.data.data.total;
            if (list == null || list.length === 0) {
              // 加载结束
              that.finished = true;
              that.finishedText = "暂无数据";
              return;
            }
            // 将新数据与老数据进行合并
            if (this.pageNum > 1) {
              that.shareList = [...that.shareList, ...list];
            } else {
              that.shareList = list;
            }
            //如果列表数据条数>=总条数，不再触发滚动加载
            if (that.shareList.length >= that.total) {
              that.finished = true;
              that.finishedText = "我也是有底线的~~~";
            }
            if (that.total < 5) {
              return;
            }
            // 如果总页数大于当前页码，页码+1
            if (res.data.data.pages > that.pageNum) {
              that.pageNum++;
            }
            // if (that.shareList.length === 0) {
            //   that.showShareList = false;
            // }
            // }else {
            //   Toast(res.responseResult.responseMsg)
          }
        });
    },
    onClick(name, title) {
      this.pageNum = 1;
      this.finished = false;
      this.listType = name;
      this.onLoad();
    },
    changeUpLoadType(name, title) {
      this.pageNum = 1;
      this.finished = false;
      this.total = 0;
      this.uploadedList = [];
      this.shareList = [];
      this.upLoadListType = name;
      this.onLoad();
    },
    delArticle(e, id) {
      var that = this;
      e.stopPropagation();
      that.delTip = true;
      that.current_actId = id;
    },
    confirmdelArticle() {
      this.$fetchPost(URL.del.url, {
        artcId: this.current_actId,
        artcType: this.upLoadType
      }).then(res => {
        Toast("删除成功");
        this.pageNum = 1;
        this.delTip = false;
        this.getUploadedList();
      });
    },
    cancel() {
      this.delTip = false;
    },

    getFormatDate(timestamp) {
      let publishDate = "";
      if (timestamp) {
        const date = new Date(timestamp);
        const Y = date.getFullYear() + "-";
        const M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        const D =
          date.getDate() < 10
            ? "0" + date.getDate() + " "
            : date.getDate() + " ";
        publishDate = Y + M + D;
      }
      return publishDate;
    },
    goToDetails(id) {
      if (this.upLoadType == "ARTORIG" || this.upLoadType == "ARTUPLD") {

        this.$router.push({
          name: "articleDetails",
          query: {
            articleId: id,
            showLongBtn: "n"
          }
        });
      } else {
        this.$router.push({
          name: "video",
          query: {
            articleId: id
          }
        });
      }
    },
    gotoEditPage(e, id) {
      e.stopPropagation();
      this.$router.push({
        path: "/articleUpload",
        query: {
          article_id: id,
          artcType: this.upLoadType
        }
      });
    },
    onLoad() {
      if (this.listType === "upload") {
        // this.showList = true;
        this.getUploadedList();
      } else {
        // this.showList = true;
        this.getSharedList();
      }
    },
    onRefresh() {
      this.pageNum = 1;
      this.finished = false;
      if (this.name === "upload") {
        this.showList = true;
        this.getUploadedList();
      } else {
        this.showList = true;
        this.getSharedList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.launch-btn {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0px;
  left: 0;
  opacity: 0;
  overflow: hidden;
}
.uploaded-page {
  position: relative;
  height: 100%;
  background: #f6f6f6;
  .tab {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    background: #fff;
    .van-tabs.first_tab {
      margin-top: 12px;
      /deep/ .van-tabs__wrap {
        .van-tab {
          font-size: 18px !important;
          font-weight: 500 !important;
          line-height: 60px;
          color: #333;
        }
        .van-tab--active {
          font-weight: bold !important;
        }
      }
    }

    .van-tabs.secondTab {
      /deep/ .van-tabs__nav {
        .van-tabs__line {
          bottom: 20px !important;
        }
        .van-tab {
          font-size: 16px;
          line-height: 38px;
          color: #666;
        }
        .van-tab--active {
          font-weight: bold;
        }
      }

      .van-tabs__content {
        margin-top: 10px;
      }
    }
  }
  .content {
    position: relative;
    background: #f5f5f5;
    padding: 0 16px;
    padding-top: 108px;

    .list_item {
      align-items: center;
      padding: 6px 12px;
      margin-bottom: 8px;
      background: #fff;
      border-radius: 4px;
    }
    .article_list {
      .article_pic_wrap {
        display: flex;
        margin-top: 16px;
        margin-bottom: 10px;
        justify-content: space-between;
        .van-image {
          /deep/.van-image__error,
          /deep/ .van-image__img,
          /deep/ .van-image__loading {
            border-radius: 3px;
          }
        }
      }
      .article_info {
        max-width: 200px;
        height: 70px;
        // margin-right: 20px;
        .article_title {
          font-size: 16px;
          line-height: 22px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
    .img_list {
      .img_title {
        position: relative;
        line-height: 22px;
        margin-top: 16px;
        font-size: 16px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .img_wrap {
        display: flex;
        flex-wrap: wrap;
        padding: 8px 0;
        .van-image {
          width: 30%;
          height: 80px;
          margin: 4px;
          /deep/.van-image__error,
          /deep/ .van-image__img,
          /deep/ .van-image__loading {
            border-radius: 3px;
          }
        }
        .van-image:nth-child(3n-1) {
          // margin: 4px 5%;
        }
      }
    }
    .video_list {
      .video_title {
        line-height: 22px;
        font-size: 16px;
        margin-top: 16px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .video_wrap {
        padding: 8px 0;
        video {
          width: 100%;
          background: #000;
          border-radius: 4px;
        }
      }
    }
    .van-list {
      /deep/ .van-list__error-text,
      /deep/ .van-list__finished-text,
      /deep/ .van-list__loading {
        width: 100%;
      }
    }
    /deep/ .bot_info {
      display: flex;
      margin-top: 4px;
      line-height: 30px;
      justify-content: space-between;
      .date {
        line-height: 30px;
        // padding-top: 4px;
        font-size: 14px;
        color: #666666;
      }
      .shareTimes {
        line-height: 30px;
        padding-top: 4px;
        font-size: 12px;
        color: #666666;
      }
      .btnBox {
        display: flex;
        justify-content: space-between;
        .btn {
          width: 44px;
          height: 20px;
          display: flex;
          color: #333;
          font-size: 12px;
          line-height: 20px;
          margin-top: 7px;
          img {
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
        }
        .delBtn {
          margin-left: 10px;
        }
      }
    }
  }
  /deep/ .content.shareConten {
    .bot_info {
      justify-content: flex-start;
      .date_share {
        line-height: 30px;
        font-size: 12px;
        color: #333;
      }
      .shareTime {
        margin-left: 20px;
        line-height: 30px;
        font-size: 12px;
        color: #333;
      }
    }
  }

  .delTip {
    z-index: 1000;
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .block {
        width: 270px;
        border-radius: 8px;
        background-color: #fff;
        text-align: center;
        h2 {
          font-size: 18px;
          line-height: 26px;
          margin-top: 36px;
          padding-bottom: 56px;
        }
        .button_box {
          display: flex;
          padding-bottom: 24px;

          justify-content: space-around;
          div {
            width: 90px;
            border: 1px solid #999999;
            line-height: 34px;
            height: 34px;
            border-radius: 18px;
            color: #999999;
            font-size: 14px;
          }
          .confirm {
            background: #ff6927;
            color: #fff;
            border-color: #ff6927;
          }
        }
      }
    }

    /deep/ .van-dialog__header {
      font-size: 18px;
      color: #1a1a1a;
      font-weight: 500;
      padding: 0;
      margin: 37px 0 56px 0;
    }
    /deep/ .van-dialog__footer {
      border: none;
      justify-content: space-around;
      /deep/ button.van-button {
        width: 90px;
        border: 1px solid #999999;
        line-height: 34px;
        height: 34px;
        border-radius: 18px;
        color: #999999;
        font-size: 14px;
      }
      button.van-dialog__confirm {
        background: #ff6927;
        color: #fff;
        border-color: #ff6927;
      }
    }
    /deep/ [class*="van-hairline"]::after {
      border: none;
    }
  }
}
</style>
